import { logInWithToken } from "@/api/services/authentication"
import { useAuthStore } from "@/stores/useAuthStore"
import { useMutation } from "@tanstack/react-query"
import { createFileRoute, useParams, useRouter } from "@tanstack/react-router"
import { useEffect, useMemo } from "react"
import { LoginWrapper } from "toptaal-shared"

export const Route = createFileRoute("/login/$token")({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  const setToken = useAuthStore((state) => state.setToken)
  const setRefreshToken = useAuthStore((state) => state.setRefreshToken)
  const setOrganizationId = useAuthStore((state) => state.setOrganizationId)

  const { token } = useParams({ from: "/login/$token" })

  useEffect(() => {
    // Clear auth store on login
    useAuthStore.getState().logout()
  }, [])

  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationFn: async (token: string) => logInWithToken(token),
    onSuccess: async (data) => {
      const { token, refreshToken, user } = data.data

      setToken(token)
      setRefreshToken(refreshToken)
      setOrganizationId(user.organizationId)

      router.navigate({ to: "/beheer/cursisten" })
    },
  })

  useEffect(() => {
    if (!token) {
      router.navigate({ to: "/login" })
    } else {
      mutate(token)
    }
  }, [token, mutate, router])

  const statusMessage = useMemo(() => {
    if (isPending) return "Laden..."
    if (isSuccess)
      return "Je bent succesvol ingelogd! Je wordt nu doorgestuurd..."
    if (isError)
      return "Er is een fout opgetreden bij het inloggen. Probeer het opnieuw."

    return null
  }, [isPending, isSuccess, isError])

  return (
    <LoginWrapper
      title="Inloggen"
      onBackToLogin={
        isError ? () => router.navigate({ to: "/login" }) : undefined
      }
    >
      <p className="text-center">{statusMessage}</p>
    </LoginWrapper>
  )
}
